import React, { Component } from "react";
import { Modal, Select } from "antd";
import router from "umi/router";
import "./index.less";

const { Option } = Select;

class CriterionModalView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateId: "",
      isActive:'false'
    };
  }

  handleOk = () => {
    // 设置选中的模版 跳转页面
    const { handleSetEvaluateTemplate } = this.props;
    const { templateId, isActive } = this.state;
    handleSetEvaluateTemplate(templateId,isActive);
  };

  onCancel = () => {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  };

  handleChange = (val, record) => {
    const { key } = record;
    this.setState({
      templateId: val,
      isActive: key
    });
  };

  render() {
    const { templateList } = this.props;
    return (
      <Modal
        title="选择评估标准模版"
        visible
        centered
        onOk={this.handleOk}
        onCancel={this.onCancel}
      >
        <Select size="large" onChange={this.handleChange} placeholder="请选择">
          {templateList &&
            templateList.map(item => {
              return (
                <Option key={item.active} value={item.templateId}>
                  {item.templateName}
                </Option>
              );
            })}
        </Select>
      </Modal>
    );
  }
}

export default CriterionModalView;
